module.exports = __webpack_public_path__ + "static/GT-Haptik-Medium-Rotalic-f12f4be41d799e7f554552566a3c5a2a.woff";